import { useEffect, useMemo } from 'react';
import { useRouter } from 'next/router';
import { showError } from '@utils';
import { useQuery } from 'react-query';
import { QUERY_KEYS } from 'constants/queryKeys';
import { vendorsServices } from '@services';
import { normalizeVendorData } from './utils';

export const useVendorOperations = () => {
  const {
    query: { vendorId },
  } = useRouter();

  const vendorResponse = useQuery(
    [QUERY_KEYS.GET_VENDOR_KEY, vendorId],
    () => vendorsServices?.getVendorById(vendorId),
    {
      enabled: !!vendorId,
    }
  );

  const productsResponse = useQuery(
    [QUERY_KEYS.GET_PRODUCT_KEY, vendorId],
    () => vendorsServices?.getProductsByVendorId(vendorId),
    {
      enabled: !!vendorId,
    }
  );

  const vendor = useMemo(
    () =>
      normalizeVendorData({
        details: vendorResponse?.data?.data,
        products: productsResponse?.data?.data,
      }),
    [vendorResponse?.data?.data, productsResponse?.data?.data]
  );

  const refetch = () => {
    vendorResponse?.refetch();
    productsResponse?.refetch();
  };

  const loading = vendorResponse?.isFetching || productsResponse?.isFetching;

  useEffect(() => {
    if (vendorResponse?.isError) {
      showError(vendorResponse?.error);
    }
  }, [vendorResponse?.isError]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (productsResponse?.isError) {
      showError(productsResponse?.error);
    }
  }, [productsResponse?.isError]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    loading,
    vendor,
    getVendor: refetch,
  };
};
